<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/04_Pollino/Itinerari-tematici/04-it_pollino_Ciclopedonale-Castrovillari_Morano-Calabro.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Lungo le strade della Ciclovia dei Parchi</h3>
</div>
</div>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
<app-sidenav></app-sidenav>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale del Pollino</a> > <a>Esperienze e Itinerari</a> > <a class="active">Lungo le strade della Ciclovia dei Parchi</a></p>
</div>
<br>
<div class="row schedaItinerario">
    <h2>Da Laino Borgo a San Donato di Ninea</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_2_Strade-Ciclovia/01_2_S.DonatoNinea.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Un percorso affascinante che parte da Laino Borgo (280 m), il paese della grande gola rocciosa del Viadotto Italia, 
            dominato dai ruderi dell’antica fortezza longobarda di Laino Castello vecchio. 
            Si parte dall’area di sosta su Corso Umberto I e, superato il ponte sul fiume Lao, 
            si raggiunge il paese nuovo di Laino Castello. Da qui, al Km 7,7 si incrocia il bivio che conduce alla Grotta del Romito di Papasidero, 
            un sito risalente al Paleolitico davvero imperdibile; percorsi 14,5 Km la Ciclovia approda a Mormanno (830 m), 
            il paese noto per i deliziosi dolci ripieni, detti “bocconotti”, e per il monumentale Faro votivo eretto in onore ai Caduti della Grande Guerra, 
            a confine fra la Calabria e la Basilicata. Raggiunta la Piana di Campotenese che si distende fra il Pollino e l’Orsomarso, 
            dove si incontra la piacevole ciclopista che ripercorre il tracciato dell’ex Ferrovia Calabro-Lucana, 
            la Ciclovia tocca quota 1050 m per poi iniziare la discesa verso Morano Calabro (680 m), 
            il suggestivo abitato medievale a semicerchi ritratto mirabilmente da Maurits Cornelis Escher, 
            che è tra i Borghi più belli d’Italia.
            <br>
            <br>
            Da Morano Calabro (680 m) si imbocca una ciclopista molto suggestiva, tracciata sul percorso dell’ex ferrovia Calabro-lucana, 
            che conduce a Castrovillari, il centro abitato più popoloso del Pollino che ospita il Centro servizi del Parco. 
            Proseguendo sulla SP263 ci si inoltra nell’area dell’Orsomarso, caratterizzata dalla presenza di storiche comunità arbëreshe, 
            e si raggiunge prima San Basile (540 m) e poi Saracena (606 m), il paese reso celebre dal suo vino moscato. 
            Da qui la Ciclovia scende rapidamente, attraversando campagne coltivate, in direzione di Firmo (344 m) per poi risalire alla volta di Lungro (590 m), 
            sede dell’Eparchia bizantina che accoglie tutte le comunità albanesi d’Italia. Il tracciato torna a salire fino ad Acquaformosa (785 m), 
            dove si trova la splendida Chiesa Matrice, per poi ridiscendere sugli adrenalinici tornati che si susseguono a picco sulla Valle dell’Esaro. 
            Infine, un ultimo strappo in salita chiude la tappa con l’approdo al magnifico borgo fortificato di San Donato di Ninea (658 m).
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bicicletta</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>elevata</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>90,5 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>2230 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1760 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Laino Borgo</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>San Donato di Ninea</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-7 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale del Pollino.</p>
    </div>
    <div class="col-1 col-xl-1">
        <img src="../../../assets/images/04_Pollino/logo-pollino.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sui sentieri dei<br />"Patriarchi"</h1>
                        <a (click)="goToPatriarchi()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Alle origini<br />dell'avventura<br />umana</h1>
                        <a (click)="goToAvventuraUmana()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Viaggio nella<br />cultura<br />arberëshe</h1>
                        <a (click)="goToCulturaArbereshe()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini di<br />spiritualità e<br />natura</h1>
                        <a (click)="goToSpiritualitaENatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Percorsi<br />di gusto</h1>
                        <a (click)="goToPercorsiDiGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>